import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { RealtimeAlertWatcher } from './RealtimeAlertWatcher';
import { IosBottomTabBar } from './ios/IosBottomTabBar';

export function Layout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Close mobile drawer on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#F2F2F7] dark:bg-[#09090B] text-zinc-900 dark:text-white flex flex-col overflow-x-hidden transition-colors relative">
      <RealtimeAlertWatcher />
      <Navbar
        mobileMenuOpen={mobileMenuOpen}
        onToggleMobileMenu={() => setMobileMenuOpen((prev) => !prev)}
      />
      <div className="flex flex-1 relative min-w-0">
        <Sidebar
          mobileOpen={mobileMenuOpen}
          onCloseMobile={() => setMobileMenuOpen(false)}
        />
        <main className="flex-1 min-w-0 overflow-y-auto overflow-x-hidden pb-24 md:pb-6">
          <Outlet />
        </main>
      </div>
      <IosBottomTabBar />
    </div>
  );
}

